import { memo } from "react";

import { defaultToTrue } from "@Components/Modules/Helpers";

export default memo(
    (props: React.SVGProps<SVGSVGElement>) => (
        <svg {...props} viewBox="0 0 40 40" fill={props.color || "#1b2670"}>
            <path transform="rotate(-44.98 21.922 17.989)" d="M6.88 11.83h30.1v12.33H6.88z" />
            <path d="M3.08 37.01l9.79-1.09-8.71-8.71-1.08 9.8z" />
        </svg>
    ),
    defaultToTrue,
);
